import type { RefObject } from "react"
import { useLingui } from "@lingui/react/macro"
import { AssigneePicker } from "@/components/v2/assignees/assignee-picker"
import {
  fetchContactAssignees,
  updateContactAssignment,
} from "@/lib/contact-assignment-api"
import type { ContactAssignee } from "@/types/v2/contact"

// Reassign "who owns this contact?" — a contact can have
// many assignees (teammates). Thin wrapper around the
// shared `AssigneePicker` (CON-218 generalized it from this
// component): it wires the contacts fetch/update API and
// maps the presenter's `contactsCount` onto the picker's
// generic `count`.
export function ReassignContactAssignees({
  open,
  onClose,
  triggerRef,
  contactId,
  contactName,
  assignees,
  applyOptimistic,
}: {
  open: boolean
  onClose: () => void
  triggerRef: RefObject<HTMLElement | null>
  contactId: number
  contactName: string
  assignees: ContactAssignee[]
  applyOptimistic: (assignees: ContactAssignee[]) => void
}) {
  const { t } = useLingui()
  return (
    <AssigneePicker
      open={open}
      onClose={onClose}
      triggerRef={triggerRef}
      entityLabel={t`contact`}
      contextName={contactName}
      countNoun={t`contact`}
      testIdPrefix="reassign-contact"
      fetchOptions={(signal) =>
        fetchContactAssignees("", signal).then((data) => ({
          employees: data.employees.map((row) => ({
            id: row.id,
            name: row.name,
            initials: row.initials,
            color: row.color,
            role: row.role,
            email: row.email,
            count: row.contactsCount,
          })),
        }))
      }
      currentAssignees={assignees}
      applyOptimistic={applyOptimistic}
      onSave={(employeeIds) =>
        updateContactAssignment(contactId, employeeIds)
      }
    />
  )
}
